/**
 * Detects the device the user is browsing from. Sent as `metadata.device_type`
 * on onboarding analytics events; the backend normalises it against a closed
 * set, so only the three canonical values below are ever sent. Same detection
 * logic as da1timetable-website's deviceType util — keep the two in sync.
 */
export function detectDeviceType(): 'desktop' | 'tablet' | 'mobile' {
  try {
    const uaData = (navigator as any).userAgentData
    if (uaData && typeof uaData.mobile === 'boolean') {
      // userAgentData.mobile does not distinguish tablet from phone, so fall
      // through to a coarse screen check for the tablet case.
      if (!uaData.mobile) return 'desktop'
      return Math.min(window.screen.width, window.screen.height) >= 600 ? 'tablet' : 'mobile'
    }
    const ua = navigator.userAgent || ''
    if (/iPad|Android(?!.*Mobile)|Tablet|PlayBook|Silk/i.test(ua)) return 'tablet'
    if (/Mobi|Android|iPhone|iPod|Windows Phone/i.test(ua)) return 'mobile'
    return 'desktop'
  } catch {
    return 'desktop'
  }
}
